import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ArrowUpRight, BookOpen, Users, ShieldCheck } from "lucide-react";
import PageShell from "../components/PageShell";
import { Section, SectionHeading, Reveal } from "../lib/ui";

const CARDS = [
  { icon: BookOpen, overline: "How It Began", title: "Our Story", desc: "Two military veterans, twenty years of hard-earned lessons, and the firm they always wished existed.", to: "/our-story", testid: "about-link-story" },
  { icon: Users, overline: "The People", title: "Meet Us", desc: "Get to know the two people you'll actually be working with — and reach us directly.", to: "/meet-us", testid: "about-link-meet" },
  { icon: ShieldCheck, overline: "What We Do", title: "Our Services", desc: "Bespoke security, risk management, technical solutions and travel risk — explore each area.", to: "/services", testid: "about-link-services" },
];

export default function AboutPage() {
  const navigate = useNavigate();
  return (
    <PageShell>
      <section className="px-6 md:px-10 lg:px-16 pt-36 pb-4 md:pt-40 overflow-hidden">
        <div className="max-w-7xl mx-auto relative">
          <div className="absolute -top-24 right-0 h-72 w-72 rounded-full bg-gold/5 blur-3xl pointer-events-none" />
          <button onClick={() => navigate("/")} className="inline-flex items-center gap-2 text-silver/60 hover:text-gold transition-colors text-sm font-body mb-8" data-testid="about-back">
            <ArrowLeft size={16} className="rtl-flip" /> Back to home
          </button>
          <SectionHeading
            overline="About Arco Orbis2"
            title={<>A small firm with a <span className="gold-text">serious background</span>.</>}
            kicker="We're a two-person security and risk consultancy built on real operational experience — not corporate theory. Here's who we are, where we came from, and how we can help."
          />
        </div>
      </section>

      <Section>
        <div className="grid md:grid-cols-3 gap-5">
          {CARDS.map((c, i) => {
            const Icon = c.icon;
            return (
              <Reveal key={c.title} delay={i * 0.08}>
                <button onClick={() => navigate(c.to)} className="group text-left w-full h-full hairline rounded-2xl bg-ink-surface/60 p-7 hover:border-gold/40 transition-colors duration-500 flex flex-col" data-testid={c.testid}>
                  <span className="h-12 w-12 rounded-full border border-gold/30 flex items-center justify-center text-gold group-hover:bg-gold/10 transition-colors">
                    <Icon size={22} strokeWidth={1.4} />
                  </span>
                  <div className="overline text-silver/40 mt-6 mb-2">{c.overline}</div>
                  <h3 className="font-display font-light text-2xl text-white group-hover:text-gold-light transition-colors">{c.title}</h3>
                  <p className="mt-3 text-silver/60 font-body font-light text-sm leading-relaxed flex-1">{c.desc}</p>
                  <span className="mt-6 inline-flex items-center gap-2 text-sm font-body text-gold group-hover:gap-3 transition-all duration-300">Explore <ArrowUpRight size={15} /></span>
                </button>
              </Reveal>
            );
          })}
        </div>
      </Section>
    </PageShell>
  );
}
